import type { PartialOnly } from '@ipfabric/utils/types/PartialOnly';
import { z } from 'zod';
import {
  type SiteSeparationAttributeTransformation,
  siteSeparationAttributeTransformationSchemaZ,
} from './siteSeparationAttributeTransformation';
import {
  type SiteSeparationRuleCommon,
  siteSeparationRuleCommonSchemaZ,
} from './siteSeparationRuleCommon';

export const routingSwitchingWanFlags = ['serial', 'tunnel'] as const;
export type RoutingSwitchingWanFlag = (typeof routingSwitchingWanFlags)[number];

export interface RoutingSwitchingSiteSeparationRule
  extends SiteSeparationRuleCommon {
  firewall: boolean;
  minimumSiteSize: number; // minimum 1
  transformation: SiteSeparationAttributeTransformation;
  type: 'routingSwitching';
  wan: RoutingSwitchingWanFlag[];
}

export type RoutingSwitchingSiteSeparationRequestRule = PartialOnly<
  RoutingSwitchingSiteSeparationRule,
  'id'
>;

export const routingSwitchingSiteSeparationRuleSchemaZ = z
  .object({
    ...siteSeparationRuleCommonSchemaZ.shape,
    firewall: z.boolean(),
    minimumSiteSize: z.number().safe().min(1),
    transformation: siteSeparationAttributeTransformationSchemaZ,
    type: z.literal('routingSwitching'),
    wan: z
      .array(z.enum(routingSwitchingWanFlags))
      .refine((arr) => new Set(arr).size === arr.length, {
        message: 'Must be unique',
      }),
  })
  .strict();

export const routingSwitchingSiteSeparationRequestRuleSchemaZ = z
  .object({
    ...routingSwitchingSiteSeparationRuleSchemaZ.shape,
    id: z.string().uuid().optional(),
  })
  .strict();
